import React, { useState, useEffect } from 'react';
import { FaUser, FaClock, FaBrain, FaPlus } from 'react-icons/fa';
import { CgFileDocument } from "react-icons/cg";
import { MdAccessibilityNew } from 'react-icons/md';

import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import './PatientAssessment.css';
import { APIURL } from '../../../Global';
import axios from "axios";
import NewAssessment from './NewAssessment';
import { LuActivity, LuBone, LuBrain } from "react-icons/lu";
import ReAssessment from './ReAssessment';
import TiltTable from './TiltTable';
const AssessmentDashboard = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [show, setShow] = useState(false)
  const [userInfo, setUserInfo] = useState({
    id: location?.state && location.state.id,
    therapy_id: location?.state && location.state.therapy_id,
    inpatient: location?.state?.inpatient,
    mob: location?.state?.mob,
    appt: location?.state?.appt
  });
  sessionStorage.setItem('previousPath', '/tilt');
  useEffect(() => {
    patientInfo()
  }, [])

  const patientInfo = async () => {
    const tokenString = sessionStorage.getItem("usertoken");
    let str = tokenString.replace(/["]+/g, "");

    await axios.get(`${APIURL}/api/v1/doctor/patient-dashboard/?patient_id=${userInfo.id}`, {
      headers: {
        Authorization: "Token " + str,
      },
    })
      .then((res) => {
        if (res.data.status === "success") {
          setUserInfo({
            ...userInfo,
            name: res.data.data.name,
            age: res.data.data.age,
            gender: res.data.data.gender,
            photo: res.data.data.photo
          });
        }
      });
  };

  const assessments = [
    {
      type: 'general',
      name: 'General Assessment',
      icon: LuActivity,
      iconClass: 'icon-general'
    },
    {
      type: 'neuro',
      name: 'Neuro Assessment',
      icon: LuBrain,
      iconClass: 'icon-neuro'
    },
    {
      type: 'ortho',
      name: 'Ortho Assessment',
      icon: LuBone,
      iconClass: 'icon-ortho'
    },
  ];

  const CircularText = ({ text }) => {
    return (
      <div className="text">
        <div className={`text-background${userInfo?.inpatient ? ' text-background2' : ' text-background1'}`}></div>
        <p>
          {text?.split('').map((char, i) => (
            <span
              key={i}
              style={{
                fontSize: '10px',
                fontWeight: 'bold',
                transform: `rotate(${i * (180 / text.length) + (80 - i * 36)}deg)`,
                position: 'absolute',
                left: '50%',
                bottom: '0',
                transformOrigin: '0 0',
                height: '40px',
                color: 'white'
              }}
            >
              {char}
            </span>
          ))}
        </p>
      </div>
    );
  };

  return (
    <div className="dashboard-container">
      <div className="patient-header">
        <div className="sub-section-img" style={{ paddingleft: "5%" }}>
          <div className="circle">
            <img
              src={userInfo.photo}
              alt="Profile"
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                objectFit: 'cover',
                position: 'relative',
                zIndex: 3
              }}
            />
            <CircularText text={userInfo?.inpatient ? "INPATIENT" : "OUTPATIENT"} />
          </div>
        </div>
        <div>
          <div className="patient-title">
            <h1>Patient: {userInfo.name}</h1>
          </div>
          <p className="patient-info">
            Age: {userInfo.age} | Gender: {userInfo.gender}
          </p>
        </div>
      </div>

      <div className="assessment-section">
        <div className="section-title">
          <FaClock className="header-icon" />
          <h2>Assessment History</h2>
        </div>

        <div className="assessments-list">
          {assessments.map((assessment) => {
            const IconComponent = assessment.icon;
            return (
              <div key={assessment.id} onClick={() => navigate("/assessment-history", { state: { type: assessment.type, data: userInfo }, }
                // , { state: { id: id, therapy_id: data.id, mob: mobile, inpatient: inpatient }, }
              )} className="assessment-item">
                <div className="assessment-content">
                  <div className={`icon-container ${assessment.iconClass}`}>
                    <IconComponent className="assessment-icon" />
                  </div>
                  <div className="assessment-details">
                    <h3>{assessment.name}</h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: '15px' }}>
          <button className="new-assessment-btn" disabled={userInfo.appt} onClick={() => setShow('assessment')} style={{ backgroundColor: show === 'assessment' && '#1d4fd8b5' }}>
            <FaPlus className="btn-icon" />
            New Assessment
          </button>
        </div>
      </div>

      {show === 'assessment' && <NewAssessment data={userInfo} />}
    </div >
  );
};

export default AssessmentDashboard;